import styles from './Title.module.css';

function Title() {

  return (
    <div className={styles.Title}>
      <h1>A Christmas Story</h1>
      <p>By James and Mary Baker</p>
    </div>
  );
}

export default Title;
